import { withSpaContainer } from '@nab/x-spa-react';
import { createUI } from '@nab/nui-react';

// NAB-X SDK v5 decouples the UI framework from the SDK: shells must provide a
// Container composed from their UI library's createUI wrapped with the SDK's
// withSpaContainer HOC. This Container is passed to start() and every
// MiniAppInstance.
export const ShellContainer = createUI([withSpaContainer]);
